// extracted by css-extract-rspack-plugin
var _1 = "ipzNf1l8EfE4jNcP";
var _2 = "n9hAxT7ZNwHSXs2z";
var _3 = "e42JsL2AMH4_orNQ";
var _4 = "n9hAxT7ZNwHSXs2z";
var _5 = "e42JsL2AMH4_orNQ";
var _6 = "gATDoeEZQBqzjRnV";
var _7 = "gATDoeEZQBqzjRnV";
var _8 = "gnVpJM3PiB8yb4uR";
var _9 = "syao2InCdBc4gifj";
var _a = "syao2InCdBc4gifj";
var _b = "ih5O2Wh1_1UItbu8";
export { _1 as "btn", _2 as "card--draw", _3 as "card--match-day", _4 as "cardDraw", _5 as "cardMatchDay", _6 as "comp-name", _7 as "compName", _8 as "header", _9 as "match-unit", _a as "matchUnit", _b as "title" }
